// import HTTP from '@/http-common.js'
import translations from '../data/admin-translations/admin-translations.json'

const state = {
  lang: 'en',
  languages: ['en', 'fr', 'es'],
  loading: false,
  wrapperClass: null,
  translations: translations,
}

const mutations = {
  setUILang(state, lang) {
    state.lang = lang
  },
  setGlobalLoader(state, val) {
    state.loading = val
  },
  setWrapperClass(state, val) {
    state.wrapperClass = val
  },
  setTranslations: (state, translations) => {
    state.translations = translations
  },
}

const getters = {
  getStringTranslation: (state) => (key) => {
    if (!state.translations[key] || !state.translations[key][state.lang]) return ''
    return state.translations[key][state.lang]
  },
}

const actions = {
  setUILang({ commit }, lang) {
    commit('setUILang', lang)
  },
  setGlobalLoader({ commit }, val) {
    commit('setGlobalLoader', val)
  },
  setWrapperClass({ commit }, val) {
    commit('setWrapperClass', val)
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
